import { SmartImageProps } from "views/components/SmartImage";

export enum ModuleLayoutStyle {
  Orange = "Orange", // ezbuy
  Tomato = "Tomato", // 兰亭
  Flower = "Flower", // 向日葵eechic
}
export enum LinkTargetType {
  Self = "_self",
  Blank = "_blank",
}
export interface Layout {
  columnNum: number;
  rowNum: number;
  gap: number;
  /** 离parent box的距离 */
  parentGap?: number;
}
export interface International {
  text?: string;
  img?: string;
  imgTwo?: string;
}

export interface Word {
  igGroup: { [key: string]: International };
}

export interface TTextModule {
  content?: string;
  color?: string;
  lightColor?: string;
  fontSize?: string;
  link?: string;
  igGroup: { [key: string]: International };
}

export interface TTagModule {
  id: string;
  positionId: string;
  tabExpand: boolean;
  bgColor: string;
  focusBgColor: string;
  text: TTextModule;
}

export interface TModuleWithImgProps {
  key?: string;
  positionId: string;
  online: boolean;
  stickToTop?: number;
  className?: string;
  style?: React.CSSProperties;
  minWidth?: number;
  width?: number | string;
  language: string;
  isInApp?: boolean;
  placeholderBg: string;
  aTarget?: LinkTargetType;
  posterRatio?: number;
  smartImageProps?: Partial<SmartImageProps>;
  moduleIndex?: number;
}
export type TModuleProps = Omit<TModuleWithImgProps, "placeholderBg">;
export interface TCountdownModule {
  time: TTimeModule;
  text: TTextModule;
}

export interface TTimeModule {
  /**
   * @pattern ^\d+$
   */
  start: string;
  /**
   * @pattern ^\d+$
   */
  end: string;
  /**
   * @pattern ^\d+$
   */
  left: string;
}

export interface TCountdownModule {
  time: TTimeModule;
  text: TTextModule;
}
